<template>
  <div class="select-person">
    <div class="select-tree">
      <div class="title"><span>{{textType}}</span></div>
      <div class="search">
        <el-input ref="searchInput" prefix-icon="el-icon-search" v-model="filterText" placeholder="请搜索人员/群组/部门" @keyup.enter.native="searchUser"></el-input>
        <el-button @click.stop="searchUser">查询</el-button>
      </div>
      <el-tree
        :data="initData"
        show-checkbox
        node-key="id"
        ref="tree"
        :filter-node-method="filterNode"
        :check-strictly="true"
        :check-on-click-node="true"
        :default-expand-all="true"
        :props="defaultProps"
        @check-change="checkChange">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span><i :class="node.icon"></i>{{ data.name }}</span>
        </span>
      </el-tree>
    </div>
    <div class="selectedList">
      <div class="title"><span>已选择{{textType}}</span></div>
      <div class="person">
        <p v-if="isRadio==='multiple'" class="multiple-select" v-for="selected in selectedList" :key="selected.id" >
            {{selected[defaultProps.label]}}
            <i class="el-icon-close remove-select-multiple" @click="removeSeleted(selected.id)"></i>
        </p>
         <p v-if="isRadio==='radio'" v-for="(selected, index) in selectedList" :key="index">
          <el-radio v-model="radio" :label="selected.id" :disabled="selected.type==='department'||selected.type==='group'">
            {{selected[defaultProps.label]}}
          </el-radio>
          <i class="el-icon-close remove-select" @click="removeSeleted(selected.id)"></i>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SelectPerson',
  props: ['treeData', 'select', 'defaultAttr', 'single', 'disableType', 'isRadio', 'type', 'isParentSelect', 'remoteSearch'],
  data () {
    let textType = ''
    switch (this.type) {
      case 'selectNode':
        textType = '控件'
        break
      case 'group':
        textType = '候选人'
        break
      default:
        textType = '人员'
    }
    return {
      initData: [],
      initGroup: [],
      defaultCheckedKeys: [],
      selectedList: [],
      radio: '',
      defaultProps: this.defaultAttr || {children: 'children', label: 'name'},
      filterText: '',
      textType
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    },
    'select' () {
      this.init()
    }
  },
  mounted () {
    this.$refs.searchInput.focus()
    this.init()
  },
  methods: {
    init () {
      this.getData(this.treeData)
      this.initData = this.treeData
      let defaultCheckedKeys = []
      this.selectedList = []
      if (this.select) {
        this.select.forEach(m => {
          if (m.targetId) {
            this.selectedList.push({'id': m.targetId, 'name': m.name, 'type': m.type})
          }
          defaultCheckedKeys.push(m.targetId)
        })
        let defaultValue = this.select.find(m => m.defaultValue === true)
        if (defaultValue) {
          this.radio = defaultValue.targetId
        }
        this.filterText = ''
      }
      this.$refs.tree.setCheckedKeys([])
      this.$refs.tree.setCheckedKeys(defaultCheckedKeys)
    },
    filterNode (value, data) {
      if (!value) return true
      if (data[this.defaultProps.label]) {
        // 需要判断拼音和简写是否符合查询条件
        let result = [data[this.defaultProps.label]]
        data.hasOwnProperty('pinyinFirstChar') && result.push(data['pinyinFirstChar'])
        data.hasOwnProperty('pinyinName') && result.push(data['pinyinName'])
        return result.some(v => v && v.includes(value.toLocaleLowerCase()))
      }
    },
    getData (data) {
      data.forEach(m => {
        m.icon = 'icon-user'
        if (this.disableType && this.disableType.includes(m.type)) {
          m.disabled = true
        }
        if (m.type === 'user') {
          m.icon = 'fa fa-user-o'
        } else if (m.type === 'department') {
          m.icon = 'fa fa-folder-o'
        }
        if (m['children'] && m['children'].length > 0) {
          this.getData(m['children'])
        }
      })
    },
    checkChange (node, state) {
      // 选择节点内的控件父节点节点不可选择
      if (this.isParentSelect === 'noselect' && node.componentType === 'rc-form') {
        return false
      } else {
        let index = this.selectedList.findIndex(m => m.id === node.id)
        if (state) {
          if (this.single) {
            this.$refs.tree.setCheckedKeys([])
            this.$refs.tree.setCheckedKeys([`${node.id}`])
          }
          this.selectedList.push({'id': node.id, 'name': node.name, 'type': node.type})
        } else {
          if (this.radio === node.id) {
            this.radio = ''
          }
          if (index > -1) {
            this.selectedList.splice(index, 1)
          }
        }
      }
    },
    searchUser () {
      if (this.remoteSearch) {
        if (this.filterText) {
          this.$axios.get(`/auth-api/departments/departmentMemberTree?userName=${this.filterText}`)
            .then(res => {
              let data = res.data ? this.$_.cloneDeep(res.data) : []
              if (this.type === 'group') {
                this.$axios.get(`/auth-api/departments/groupMemberTree?name=${this.filterText}`).then(res => {
                  let group = res.data ? this.$_.cloneDeep(res.data) : []
                  data = data.concat(group)
                  this.getData(data)
                  this.initData = data
                })
              } else {
                this.getData(data)
                this.initData = data
              }
            })
        } else {
          this.initData = []
        }
      } else {
        this.$refs.tree.filter(this.filterText)
      }
    },

    getSelectedList () {
      return this.selectedList
    },
    getDefault () {
      return this.radio
    },
    removeSeleted (id) {
      let index = this.selectedList.findIndex(m => m.id === id)
      if (index > -1) {
        this.selectedList.splice(index, 1)
        // // 树中选中的勾选的值的取消
        this.$refs.tree.setCheckedKeys([])
        let checkedKeys = []
        this.selectedList.forEach(m => {
          checkedKeys.push(m.id)
        })
        this.$refs.tree.setCheckedKeys(checkedKeys)
      }
    }
  }

}
</script>

<style lang="scss">
  .select-person {
    white-space: nowrap;
    width: 524px;
    margin: 0 auto;
    overflow: hidden;
    > div {
      border: 1px solid #C2C3C4;
      border-radius: 4px;
      width: 232px;
      height: 279px;
      float: left;
      text-align: center;
      .title {
        width: 100%;
        height: 24px;
        background-color: #EDEEEE;
        padding-top: 3px;
        span {
          font-size: 12px;
        }
      }
    }
    .select-tree {
      .el-tree {
        height: 214px;
        overflow: auto;
      }
      .search {
        margin: 10px 10px 0 10px;
        .el-input {
          width: 160px;
        }
        .el-button {
          padding: 6px 8px;
        }
      }
      .el-tree-node__content {
        .custom-tree-node {
          font-size: 12px;
          .fa {
            padding-right: 5px;
          }
        }
      }
    }
    .selectedList {
      margin-left: 59px;
      float: left;
      .person {
        overflow: auto;
        height: 253px;
        > p {
          position: relative;
          text-align: left;
          &.multiple-select {
            padding: 3px 0 3px 10px;
            .remove-select-multiple {
              cursor: pointer;
              position: absolute;
              right: 10px;
              top: 5px;
            }
          }
          .remove-select {
            cursor: pointer;
            position: absolute;
            right: 10px;
            top: 10px;
          }
          label {
            padding-left: 14px;
            padding-top: 10px;
            .el-radio__label {
              font-size: 12px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              max-width: 168px;
              display: inline-block;
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/system/select-person.vue